export const CREATE_NEW_COMPANY = "Create New Company";
export const NO_COMPANIES_DATA = "Sorry, we couldn't find any companies."; 